<template>
  <UtilityMenu id="user-menu">
    <template #icon>
      <UserIcon
        :color="avatarColor"
        hidden-text="account menu"
        data-insert-trigger
        data-avatar="button"
      />
    </template>
    <UtilityMenuLink href="/write/account" @click.prevent="goToMyAccount"
      >My Account</UtilityMenuLink
    >
    <UtilityMenuLink href="/write/archive" @click.prevent="goToArchive"
      >Archived Documents</UtilityMenuLink
    >
    <hr />
    <UtilityMenuButton @click="logOut">Sign Out</UtilityMenuButton>
  </UtilityMenu>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

import UserIcon from '@/js/components/icons/user-icon.vue';
import { navigatePanel } from '@/js/router/panels';
import { useUserStore } from '@/js/stores/user';

export default defineComponent({
  name: 'UserMenu',
  components: { UserIcon },
  setup() {
    const userStore = useUserStore();
    const avatarColor = computed(() => userStore.user?.avatar_color);
    const logOut = computed(() => userStore.logOut);

    return {
      avatarColor,
      logOut,
    };
  },
  methods: {
    goToMyAccount(event: PointerEvent) {
      if (event.target instanceof HTMLElement) {
        event.target?.blur();
      }
      navigatePanel({
        to: 'account',
      });
    },
    goToArchive(event: PointerEvent) {
      if (event.target instanceof HTMLElement) {
        event.target?.blur();
      }
      navigatePanel({
        to: 'archive',
      });
    },
  },
});
</script>
